import { Bill, Billable, BillablesServiceResponse, BillingInfoServiceResponse, BillItem } from "../pages/hospital/Billing/types";
import { IPharmacyRequest } from "../pages/hospital/Pharmacy/types";
import { IRequest } from "../pages/hospital/Request/types";
import axios from "../utils/axios";

export function makePharmacyRequestService(uuidInvestigation:string, idPharmacy:number, request:IPharmacyRequest): Promise<{ status: number }> {
    return new Promise((resolve, reject) => {
        axios.post(import.meta.env.VITE_APP_API_URL + "/hospital/"+uuidInvestigation+"/pharmacy/"+idPharmacy+"/request", request,{ headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}


export function updatePharmacyRequestService(uuidInvestigation:string, idPharmacy:number, request:IRequest, approved:boolean): Promise<{ status: number }> {
    return new Promise((resolve, reject) => {
        const requestSend = {...request, approved};
        axios.put(import.meta.env.VITE_APP_API_URL + "/hospital/"+uuidInvestigation+"/pharmacy/"+idPharmacy+"/request/"+request.id, requestSend,{ headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

// SHER-575: ask the API which of the services about to be ordered the patient already
// has live, so the form can confirm the repeat instead of guessing. Advisory only —
// the API answers ONLY for services whose repeat it would actually accept, so a
// non-empty answer always means "warn, then proceed", never "this will be refused".
export function getDuplicateRequestWarningsService(uuidInvestigation:string, uuidPatientInvestigation:string, servicesInvestigationId:number[]): Promise<{ status: number, warnings: { serviceInvestigationId:number, lastRequestedAt:string }[] }> {
    return new Promise((resolve, reject) => {
        axios.get(import.meta.env.VITE_APP_API_URL + "/hospital/"+uuidInvestigation+"/patient/"+uuidPatientInvestigation+"/request/duplicate-warnings",
            { params: { servicesInvestigationId: servicesInvestigationId.join(',') }, headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

// SHER-366: add a missing service to an existing request (gated by MODIFY_REQUESTS).
export function addServiceToRequestService(uuidInvestigation:string, idRequest:number, servicesInvestigationId:number[], reason:string): Promise<{ status: number, request?: IRequest }> {
    return new Promise((resolve, reject) => {
        axios.post(import.meta.env.VITE_APP_API_URL + "/hospital/"+uuidInvestigation+"/request/"+idRequest+"/service", { servicesInvestigationId, reason },{ headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

// SHER-411: mark a paid radiology/cordonnerie request as performed (COMPLETED) without
// a report upload (UPDATE_LAB_REQUESTS). The API restricts this to IMAGE/SHOE + ACCEPTED.
export function completeManualRequestService(uuidInvestigation:string, idRequest:number): Promise<{ status: number, request?: IRequest }> {
    return new Promise((resolve, reject) => {
        axios.put(import.meta.env.VITE_APP_API_URL + "/hospital/"+uuidInvestigation+"/request/"+idRequest+"/complete", {},{ headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

// SHER-908: record that the patient collected a finished cordonnerie order. Same authority
// as manual completion (UPDATE_LAB_REQUESTS); the API restricts it to SHOE + COMPLETED.
export function deliverMaterialRequestService(uuidInvestigation:string, idRequest:number): Promise<{ status: number, request?: IRequest }> {
    return new Promise((resolve, reject) => {
        axios.put(import.meta.env.VITE_APP_API_URL + "/hospital/"+uuidInvestigation+"/request/"+idRequest+"/deliver", {},{ headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

// SHER-366: remove an over-ordered (unpaid) service from a request (MODIFY_REQUESTS).
export function removeServiceFromRequestService(uuidInvestigation:string, idRequest:number, idRequestServiceInvestigation:number, reason:string): Promise<{ status: number, request?: IRequest }> {
    return new Promise((resolve, reject) => {
        axios.delete(import.meta.env.VITE_APP_API_URL + "/hospital/"+uuidInvestigation+"/request/"+idRequest+"/service/"+idRequestServiceInvestigation, { headers: { "Authorization": localStorage.getItem("jwt") }, data: { reason } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

// SHER-366: cancel a whole request (gated by CANCEL_REQUESTS).
export function cancelRequestService(uuidInvestigation:string, idRequest:number, reason:string): Promise<{ status: number, request?: IRequest }> {
    return new Promise((resolve, reject) => {
        axios.post(import.meta.env.VITE_APP_API_URL + "/hospital/"+uuidInvestigation+"/request/"+idRequest+"/cancel", { reason },{ headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}


